import { HttpBackend, HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { APP_CONFIG } from '@pulpo/app-config';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

export interface HewagoDetailLink {
  exists: boolean;
  // Le back Hewago renvoie `url` (string ou array) ; on tolère aussi `urls`.
  url?: string | string[];
  urls?: string | string[];
}

@Injectable({
  providedIn: 'root',
})
export class HewagoService {
  private readonly environment = inject(APP_CONFIG);
  // HttpClient construit sur HttpBackend : contourne les intercepteurs DI
  // (pas de header Authorization ni de snackbar d'erreur globale vers Hewago)
  private readonly http = new HttpClient(inject(HttpBackend));

  getDetailLinks(businessId: string): Observable<string[]> {
    if (!this.environment.hewagoUrl) {
      return of([]);
    }
    return this.http
      .get<HewagoDetailLink>(
        `${this.environment.hewagoUrl}/pulpo_ref/${businessId}/detail_link`
      )
      .pipe(
        map((res) => {
          if (!res?.exists) {
            return [];
          }
          const raw = res.url ?? res.urls;
          const urls = Array.isArray(raw) ? raw : raw ? [raw] : [];
          return urls.filter((url) => !!url);
        }),
        catchError(() => of([]))
      );
  }
}
